import pageText from '../content/TermsOfUse.md?raw';
import LegalPageLayout from './LegalPageLayout';

export default function TermsOfUsePage() {
  return <LegalPageLayout content={pageText} />;
}
